module.exports = __webpack_public_path__ + "img/rarity-shape1.652fefb4.png";